import React from 'react';
import { GraduationCap, Award, BookOpen } from 'lucide-react';
import { educationData, certificationsData } from '../data/mock';

const Education = () => {
  return (
    <section id="education" className="py-24 bg-[#faf6ee]" data-testid="education-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-gold-400/10 text-gold-400 text-sm font-semibold rounded-full mb-4">
            Qualifications
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#152846] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            Education & <span className="text-gold-400">Certifications</span>
          </h2>
          <p className="text-lg text-[#5c6878] max-w-2xl mx-auto">
            Continuous learning and professional development
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          <div>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 bg-gold-400/10 rounded-xl flex items-center justify-center">
                <GraduationCap className="w-6 h-6 text-gold-400" strokeWidth={2.5} />
              </div>
              <h3 className="text-2xl font-bold text-[#152846]" style={{ fontFamily: "'Playfair Display', serif" }}>Education</h3>
            </div>
            <div className="space-y-6">
              {educationData.map((edu) => (
                <div
                  key={edu.id}
                  className={`relative p-6 bg-[#fffdf8] rounded-2xl border-l-4 ${
                    edu.current ? 'border-gold-400' : 'border-[#e6dfd0]'
                  } hover:border-gold-400/50 transition-all duration-300`}
                  data-testid={`education-card-${edu.id}`}
                >
                  {edu.current && (
                    <span className="absolute top-4 right-4 px-3 py-1 bg-gold-400/10 text-gold-400 text-xs font-semibold rounded-full">
                      In Progress
                    </span>
                  )}
                  <h4 className="text-lg font-bold text-[#152846] mb-1 pr-24">{edu.degree}</h4>
                  <p className="text-gold-400 font-medium mb-2">{edu.field}</p>
                  <p className="text-[#5c6878] text-sm mb-1">{edu.institution}</p>
                  <p className="text-[#8b94a3] text-sm">{edu.year}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 bg-gold-400/10 rounded-xl flex items-center justify-center">
                <Award className="w-6 h-6 text-gold-400" strokeWidth={2.5} />
              </div>
              <h3 className="text-2xl font-bold text-[#152846]" style={{ fontFamily: "'Playfair Display', serif" }}>Certifications</h3>
            </div>
            <div className="space-y-4">
              {certificationsData.map((cert, index) => (
                <div
                  key={index}
                  className="group flex items-start gap-4 p-5 bg-[#fffdf8] rounded-xl border border-[#e6dfd0] hover:border-gold-400/30 transition-all duration-300 hover:-translate-y-0.5"
                  data-testid={`cert-card-${index}`}
                >
                  <div className="w-10 h-10 bg-gold-400/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-gold-400/20 transition-colors">
                    <BookOpen className="w-5 h-5 text-gold-400" strokeWidth={2.5} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-[#3e4858] group-hover:text-gold-400 transition-colors">
                      {cert}
                    </h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;
